import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { connect } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { PowerBIEmbed } from 'powerbi-client-react';
import { IEmbedConfiguration, Report } from 'powerbi-client';
import { RootState } from '../store';

import { getPowerBIEmbed, setPlanFilter } from './reportActions';
import { ValidReportName } from './types';
import { IncompleteTheme } from '../shared/types/theme';
import { isReport } from './utils';
import { getMasterPlans } from '../providerSearch/actions';

const useStyles = makeStyles<IncompleteTheme>(theme => ({
  pbiEmbed: {
    width: '100%',
    paddingLeft: '1.5rem',
    boxSizing: 'border-box',
    '& iframe': {
      border: 'none',
    },
  },
}));

type StateProps = {
  config: IEmbedConfiguration;
  isEmbedFetched: boolean;
  selectedReportName: ValidReportName | '';
  selectedReportPage: string;
  plans: any;
};
const mapStateToProps = ({ reports, planSelect }: RootState): StateProps => {
  return {
    config: reports.config,
    isEmbedFetched: reports.isEmbedFetched,
    selectedReportName: reports.selectedReportName,
    selectedReportPage: reports.selectedReportPage,
    plans: planSelect.masterPlans,
  };
};

const mapDispatchToProps = {
  getPowerBIEmbed,
  getMasterPlans,
  setPlanFilter,
};

type Props = StateProps & typeof mapDispatchToProps;

export function PowerBI({
  getPowerBIEmbed,
  getMasterPlans,
  setPlanFilter,
  config,
  selectedReportName,
  isEmbedFetched,
  plans,
}: Props): JSX.Element {
  const classes = useStyles();
  const [embed, setEmbed] = useState<Report | null>(null);

  const location = useLocation();

  useEffect(() => {
    if (plans && plans.length <= 0) {
      getMasterPlans();
    }
    if (location.pathname.includes('monthly-reporting')) {
      getPowerBIEmbed('monthly-reporting');
    } else if (location.pathname.includes('planHealth-reporting')) {
      getPowerBIEmbed('planHealth-reporting');
    } else if (location.pathname.includes('providerAcceptance-reporting')) {
      getPowerBIEmbed('providerAcceptance-reporting');
    }
    const initialPlan = plans && plans[0];
    setPlanFilter(initialPlan);
  }, [getPowerBIEmbed, selectedReportName, plans, location.pathname]);

  useEffect(() => {
    if (embed && config.pageName) {
      embed.setPage(config.pageName);
    }
  });

  useEffect(() => {
    if (embed && config.filters) {
      embed.setFilters(config.filters);
    }
  }, [embed, config]);

  return (
    <PowerBIEmbed
      embedConfig={config}
      cssClassName={classes.pbiEmbed}
      getEmbeddedComponent={(embed): void => {
        if (isEmbedFetched && isReport(embed)) {
          setEmbed(embed);
        }
      }}
    />
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PowerBI);
